/* Native modal provides focus containment and Escape; one instance serves all core sections. */
(() => {
  const drawer = document.getElementById('GrovaNutritionDrawer');
  if (!drawer || drawer.dataset.initialized) return;
  drawer.dataset.initialized = 'true';
  const ingredients = drawer.querySelector('.grova-nutrition-drawer__ingredients');
  if (ingredients) {
    const summary = ingredients.querySelector('summary');
    const answer = ingredients.querySelector('div');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let ingredientAnimation;
    let expanded = ingredients.open;
    function settleIngredients() {
      ingredientAnimation?.cancel();
      ingredientAnimation = null;
      ingredients.open = expanded;
    }
    summary.addEventListener('click', event => {
      event.preventDefault();
      const height = ingredients.open ? answer.getBoundingClientRect().height : 0;
      ingredientAnimation?.cancel();
      ingredientAnimation = null;
      expanded = !expanded;
      ingredients.dataset.expanded = String(expanded);
      summary.setAttribute('aria-expanded', String(expanded));
      if (reducedMotion.matches || !answer.animate) {
        ingredients.open = expanded;
        return;
      }
      ingredients.open = true;
      const animation = answer.animate(
        [{ height: `${height}px` }, { height: expanded ? `${answer.scrollHeight}px` : '0px' }],
        { duration: 280, easing: 'cubic-bezier(.22, .61, .36, 1)', fill: 'both' },
      );
      ingredientAnimation = animation;
      animation.onfinish = () => {
        if (ingredientAnimation === animation) settleIngredients();
      };
    });
    reducedMotion.addEventListener('change', () => {
      if (reducedMotion.matches) settleIngredients();
    });
    drawer.addEventListener('close', settleIngredients);
  }
  let returnFocus;
  let closeTimer;
  let releasePageScroll;
  function closeDrawer() {
    if (!drawer.open || drawer.classList.contains('is-closing')) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      drawer.close();
      return;
    }
    drawer.classList.add('is-closing');
    const timing = getComputedStyle(drawer).getPropertyValue('--grova-drawer-duration').trim();
    const duration = (parseFloat(timing) * (timing.endsWith('ms') ? 1 : 1000)) || 300;
    closeTimer = setTimeout(() => drawer.close(), duration);
  }
  drawer.addEventListener('cancel', event => {
    event.preventDefault();
    closeDrawer();
  });
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-nutrition-open]');
    if (!trigger || drawer.open) return;
    // Acquire before closing Ingredients so the page stays frozen during handoff.
    releasePageScroll = window.GrovaPageScroll.lock(drawer);
    const detail = { returnFocus: trigger };
    trigger.dispatchEvent(new CustomEvent('grova:nutrition-open', { bubbles: true, detail }));
    returnFocus = detail.returnFocus || trigger;
    drawer.showModal();
    drawer.scrollTop = 0;
    drawer.querySelector('[data-nutrition-close]').focus({ preventScroll: true });
  });
  drawer.querySelector('[data-nutrition-close]').addEventListener('click', closeDrawer);
  let backdropPress = false;
  const outside = (event) => {
    const rect = drawer.getBoundingClientRect();
    return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
  };
  // Native dialog inertness handles focus; boundary guards also stop scroll chaining.
  let touchY = 0;
  const atBoundary = delta => delta < 0 ? drawer.scrollTop <= 0
    : delta > 0 && drawer.scrollTop + drawer.clientHeight >= drawer.scrollHeight - 1;
  const inside = event => drawer.contains(event.target) &&
    !(event.target === drawer && 'clientX' in event && outside(event));
  document.addEventListener('wheel', event => {
    if (drawer.open && (!inside(event) || atBoundary(event.deltaY))) event.preventDefault();
  }, { passive: false });
  document.addEventListener('touchstart', event => {
    if (drawer.open) touchY = event.touches[0]?.clientY || 0;
  }, { passive: true });
  document.addEventListener('touchmove', event => {
    if (!drawer.open) return;
    const y = event.touches[0]?.clientY || 0;
    const touch = event.touches[0];
    if (!drawer.contains(event.target) || (touch && outside(touch)) || atBoundary(touchY - y)) event.preventDefault();
    touchY = y;
  }, { passive: false });
  document.addEventListener('keydown', event => {
    if (drawer.open && !drawer.contains(event.target) &&
      ['ArrowDown', 'ArrowUp', 'PageDown', 'PageUp', 'Home', 'End', ' '].includes(event.key)) event.preventDefault();
  });
  drawer.addEventListener('pointerdown', (event) => { backdropPress = event.target === drawer && outside(event); });
  drawer.addEventListener('click', (event) => {
    if (backdropPress && event.target === drawer && outside(event)) closeDrawer();
    backdropPress = false;
  });
  drawer.addEventListener('close', () => {
    clearTimeout(closeTimer);
    drawer.classList.remove('is-closing');
    releasePageScroll?.();
    releasePageScroll = null;
    if (returnFocus?.isConnected) returnFocus.focus({ preventScroll: true });
  });
})();
